"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyTag = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
exports.KeyTag = ({ children, mini }) => {
    return (react_1.default.createElement("div", { className: classnames_1.default('command-palette-key-tag', { mini: !!mini }) }, children));
};
//# sourceMappingURL=key-tag.js.map